var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileStep1Chrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 1.75h-10.5c-1.93 0-3.5 1.57-3.5 3.5v24.5c0 1.93 1.57 3.5 3.5 3.5h10.5c1.93 0 3.5-1.57 3.5-3.5v-24.5c0-1.93-1.57-3.5-3.5-3.5Zm-10.5-1.75c-2.9 0-5.25 2.35-5.25 5.25v24.5c0 2.9 2.35 5.25 5.25 5.25h10.5c2.9 0 5.25-2.35 5.25-5.25v-24.5c0-2.9-2.35-5.25-5.25-5.25h-10.5Z",
    fill: "#eb2553"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10.25h-9c-1.24 0-2.25 1.01-2.25 2.25v9c0 1.24 1.01 2.25 2.25 2.25h9c1.24 0 2.25-1.01 2.25-2.25v-9c0-1.24-1.01-2.25-2.25-2.25Zm-9-1.5c-2.07 0-3.75 1.68-3.75 3.75v9c0 2.07 1.68 3.75 3.75 3.75h9c2.07 0 3.75-1.68 3.75-3.75v-9c0-2.07-1.68-3.75-3.75-3.75h-9Z",
    fill: "#000",
    className: "darkModed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81 12.87v8.26h-1.04v-6.96l-2.11 .77v-0.94l2.99-1.13h.16Z",
    fill: "#000",
    className: "darkModed"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    className: "darkModed",
    d: "M49.32 10.92c0 1.2-0.98 2.17-2.17 2.17c-1.2 0-2.18-0.97-2.18-2.17c0-1.2 .98-2.17 2.18-2.17c1.2 0 2.17 .97 2.17 2.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    className: "darkModed",
    d: "M49.32 17c0 1.2-0.98 2.17-2.17 2.17c-1.2 0-2.18-0.97-2.18-2.17c0-1.2 .98-2.17 2.18-2.17c1.2 0 2.17 .97 2.17 2.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    className: "darkModed",
    d: "M49.32 23.08c0 1.2-0.98 2.17-2.17 2.17c-1.2 0-2.18-0.97-2.18-2.17c0-1.2 .98-2.17 2.18-2.17c1.2 0 2.17 .97 2.17 2.17Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileStep1Chrome);
export default __webpack_public_path__ + "static/media/mobile-step1-chrome.6ff49588d214128aff182b5f21248bf4.svg";
export { ForwardRef as ReactComponent };